import React from "react";

import { faDesktop, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { screenResize } from "actions";

import { MultiButton } from "components/Button";
import IdConnectedList from "components/IdConnectedList";
import { Mobile2x1Layout } from "components/Layout/ContentHeader";
import WaitForSync from "components/LoadingSpinner/WaitForSync";
import MessageBox from "components/MessageBox";
import { Nomination } from "components/Nominations/Cards/Nomination";
import { tryAndOpenNominationsModal } from "components/Nominations/Table";
import { SearchHeader } from "components/SearchInput/GlobalSearch";

import { ApiModel } from "constants/loading";
import { DeploymentPermissions } from "constants/permissions";

import {
  getLivestockSaleId,
  getNominationTableRoute,
  getSaleyardName,
} from "lib/navigation";

import {
  getIsNominationsLocked,
  selectOrderedNominationIds,
  selectRoleCurrentDeployments,
} from "selectors";

import { useTheme } from "hooks";
import { useSomeHasPermission } from "hooks/useHasPermission";

import { NominationOverview } from "./NominationOverview";

function EmptyNominations() {
  const hasCreatePermission = useSomeHasPermission(
    selectRoleCurrentDeployments,
    DeploymentPermissions.canNominateFor,
  );
  return (
    <MessageBox>
      No Nominations yet.
      {hasCreatePermission && " Click Create Nomination to get started"}
    </MessageBox>
  );
}

export const NominationCards = () => {
  const nominationIds = useSelector(selectOrderedNominationIds);
  const dispatch = useDispatch();
  const history = useHistory();
  const hasCreatePermission = useSomeHasPermission(
    selectRoleCurrentDeployments,
    DeploymentPermissions.canNominateFor,
  );

  const theme = useTheme();

  const nominationsLocked = useSelector(getIsNominationsLocked);

  const nominationActions = [
    hasCreatePermission && {
      title: "Nomination",
      isDisabled: false,
      onClick: () => tryAndOpenNominationsModal(nominationsLocked),
      default: true,
      icon: faPlus,
      dataTour: "addNomination",
    },
    {
      title: "Desktop View",
      icon: faDesktop,
      onClick: () => {
        dispatch(screenResize(theme.breakpoints[2]));
        history.push(
          getNominationTableRoute(getSaleyardName(), getLivestockSaleId()),
        );
      },
      dataTour: "desktopView",
    },
  ].filter(Boolean);

  return (
    <WaitForSync
      requiredData={[
        ApiModel.SALE_LOTS,
        ApiModel.CONSIGNMENTS,
        ApiModel.BUSINESSES,
        ApiModel.NOMINATIONS,
      ]}
    >
      <SearchHeader
        actionButton={<MultiButton buttons={nominationActions} />}
        layout={Mobile2x1Layout}
      />
      <NominationOverview />
      <IdConnectedList
        component={Nomination}
        emptyComponent={EmptyNominations}
        orderedIds={nominationIds}
      />
    </WaitForSync>
  );
};
